/*
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-04-21 15:32:27
 * @FilePath: \watherfocast2\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Statistics from '../views/Statistics.vue'
import Predictive from '../views/Predictive.vue'
import Login from '../views/Login.vue'
import { isAdmin } from '../utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/manual',
    name: 'UserManual',
    component: () => import(/* webpackChunkName: "UserManual" */ '../views/UserManual.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/Statistics',
    name: 'Statistics',
    component: Statistics,
    meta: { requiresAuth: true },
    redirect: '/Statistics/RainfallData',
    children: [
      {
        path: 'RainfallData',
        name: 'RainfallData',
        component: () => import(/* webpackChunkName: "RainfallData" */ '../views/StationData.vue')
      },
      {
        path: 'ForecastData',
        name: 'ForecastData',
        component: () => import(/* webpackChunkName: "ForecastData" */ '../views/ForecastData.vue')
      },
      {
        path: 'VerificationResult',
        name: 'VerificationResult',
        component: () => import(/* webpackChunkName: "VerificationResult" */ '../views/VerificationResult.vue')
      },
      {
        path: 'WarnList',
        name: 'WarnList',
        component: () => import(/* webpackChunkName: "WarnList" */ '../views/WarnList.vue')
      }
    ]
  },
  {
    path: '/Predictive',
    name: 'Predictive',
    component: Predictive,
    meta: { requiresAuth: true },
    redirect: '/Predictive/VerificationResult',
    children: [
      {
        path: 'VerificationResult',
        name: 'PredictiveVerificationResult',
        component: () => import(/* webpackChunkName: "VerificationResult" */ '../views/VerificationResult.vue')
      },
      {
        path: 'MonthlyAssessment',
        name: 'PredictiveMonthlyAssessment',
        component: () => import(/* webpackChunkName: "MonthlyAssessment" */ '../views/MonthlyAssessment.vue')
      },
      {
        path: 'FlowComparison',
        name: 'PredictiveFlowComparison',
        component: () => import(/* webpackChunkName: "FlowComparison" */ '../views/FlowComparison.vue')
      }
    ]
  },
  {
    path: '/upstream-flow-entry',
    name: 'UpstreamFlowEntry',
    component: () => import(/* webpackChunkName: "UpstreamFlowEntry" */ '../views/UpstreamFlowEntry.vue')
  },
  {
    path: '/flow-entry',
    name: 'FlowEntry',
    component: () => import(/* webpackChunkName: "FlowEntry" */ '../views/FlowEntry.vue')
  },
  {
    path: '/interval-flow-entry',
    name: 'IntervalFlowEntry',
    component: () => import(/* webpackChunkName: "IntervalFlowEntry" */ '../views/IntervalFlowEntry.vue')
  },
  {
    path: '/out-flow-entry',
    name: 'OutFlowEntry',
    component: () => import(/* webpackChunkName: "OutFlowEntry" */ '../views/OutFlowEntry.vue')
  },
  {
    path: '/admin',
    name: 'AdminPermission',
    component: () => import(/* webpackChunkName: "AdminPermission" */ '../views/AdminPermission.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫 - 登录验证
router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem('isLoggedIn')
  
  if (to.meta && to.meta.requiresAuth && !isLoggedIn) {
    // 需要登录但未登录，跳转到登录页
    next('/login')
  } else if (to.meta && to.meta.requiresAdmin && isLoggedIn && !isAdmin()) {
    // 非管理员访问权限配置页，回到首页
    next('/')
  } else if (to.path === '/login' && isLoggedIn) {
    // 已登录但访问登录页，跳转到首页
    next('/')
  } else {
    next()
  }
})

export default router
